import camelCase         from 'lodash/camelCase'
import VaccineController from '../../vaccine_controller'
import WizardMixin       from '../../../../support/wizard_mixin'
import $fq               from '../../../../support/fake_query'
import mixin             from '../../../../support/mixin'

export default class extends mixin(VaccineController, WizardMixin) {

  static targets = [
    ...super.targets,
    'currentBatchNumber',
    'currentExpiryDate',
    'currentLocationContainer',
    'currentRoute',
    'historicalBatchNumber',
    'historicalExpiryDate',
    'historicalLocationContainer',
    'historicalRoute',
    'influenzaAdministeredDetails',
    'influenzaNotAdministeredDetails',
    'medicalReasonDetails',
    'otherReasonDetails'
  ]

  setCurrentState() {
    this.syncBatchAndExpiry('historical', 'current')

    this.historicalFieldTargets.forEach((target) => {
      this.hideTarget(target)
    })
    this.hideTarget(this.historicalLocationContainerTarget)

    this.currentFieldTargets.forEach((target) => {
      this.showTarget(target)
    })
    if (this.showAdministrationLocation(this.currentRouteTarget.value)) {
      this.showTarget(this.currentLocationContainerTarget)
    } else {
      this.hideTarget(this.currentLocationContainerTarget)
    }
  }

  setHistoricalState() {
    this.syncBatchAndExpiry('current', 'historical')

    this.historicalFieldTargets.forEach((target) => {
      this.showTarget(target)
    })
    if (this.showAdministrationLocation(this.historicalRouteTarget.value)) {
      this.showTarget(this.historicalLocationContainerTarget)
    } else {
      this.hideTarget(this.historicalLocationContainerTarget)
    }

    this.currentFieldTargets.forEach((target) => {
      this.hideTarget(target)
    })
    this.hideTarget(this.currentLocationContainerTarget)
  }

  syncBatchAndExpiry(from, to) {
    const batchFrom  = `${from}BatchNumberTarget`
    const batchTo    = `${to}BatchNumberTarget`
    const expiryFrom = `${from}ExpiryDateTarget`
    const expiryTo   = `${to}ExpiryDateTarget`

    if (this[batchFrom] && this[batchTo] && this[batchFrom].value !== '') {
      this[batchTo].value = this[batchFrom].value
    }

    if (this[expiryFrom] && this[expiryTo] && this[expiryFrom].value !== '') {
      this[expiryTo].value = this[expiryFrom].value
    }
  }

  toggleInfluenzaAdministeredDetails({ currentTarget }) {
    this.toggleNoneInverseSelection({
      input:  currentTarget,
      target: this.influenzaAdministeredDetailsTarget
    })

    this.toggleCheckboxMoreDetails({
      input:  currentTarget,
      target: this.influenzaNotAdministeredDetailsTarget
    })
  }

  toggleInfluenzaNotAdministeredReasonDetails({ currentTarget }) {
    [
      { value: 'medical_reason', target: this.medicalReasonDetailsTarget },
      { value: 'other', target: this.otherReasonDetailsTarget }
    ].forEach((obj) => {
      if (currentTarget.value === obj.value) {
        this.showRadioButtonMoreDetails({
          target: obj.target
        })
      } else {
        this.hideRadioButtonMoreDetails({
          target: obj.target
        })
      }
    })
  }

  routeChanged({ currentTarget, params: { vaccineType } }) {
    const locationContainerTargetKey = camelCase(`${vaccineType}_location_container_target`)

    if (this.showAdministrationLocation(currentTarget.value)) {
      $fq(this[locationContainerTargetKey]).show()
    } else {
      $fq(this[locationContainerTargetKey]).hide()
    }
  }

  showAdministrationLocation(value) {
    const locationRequired = [
      'intradermal',
      'intramuscular_injection',
      'intravenous_infusion',
      'subcutaneous'
    ]
    return locationRequired.includes(value) === true
  }

  get hideClass() {
    return 'u-hide'
  }

}
